import Search from './search';

export default Search;



// WEBPACK FOOTER //
// ./containers/search/index.js